import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex';
import * as types from '@reserve/store/types'

import ResourceItem from './ResourceItem.vue';

@Component({
    components: {
        ResourceItem
    },

    computed: mapGetters({
        isLoading: types.CALENDAR_LOADING,
        selectedResourceKeys: types.SELECTED_RESOURCE_KEYS
    }),

    methods: mapActions({
        selectGroup: types.TOGGLE_RESOURCEGROUP_SELECT
    })
})
export default class ResourceGroup  extends Vue {
    @Prop({ type: Object }) item!: ewsResource.EwsResourceItem;

    selectGroup!: (payload: { category: 'EWS' | 'DB' | 'FAVORITE', id: string, select: boolean }) => void;

    selectedResourceKeys!: string[];
    isLoading!: boolean;
    selected: boolean = false;
    isCollapsed : boolean = false

    @Watch('selectedResourceKeys')
    OnSelectChanged(newVal: string[]) {
        this.selected = newVal.indexOf(`${this.item.uniqueId}-${this.item.uniqueId}`) >= 0;                
    }

    created() {
        this.selected = this.item.selected || this.selectedResourceKeys.indexOf(`${this.item.uniqueId}-${this.item.uniqueId}`) >= 0;
        
        var childIds = this.item.childItems.map(c => { return `${c.uniqueId}-${c.parentId}`});
        this.isCollapsed = childIds.length > 0 && childIds.some(c => this.selectedResourceKeys.indexOf(c) >= 0);
    }

    selectChanged() {
        this.selectGroup({ category: 'EWS', id: this.item.uniqueId, select: this.selected });
    }     

    onToggleFoldClick() {
        this.isCollapsed = !this.isCollapsed;
    }
}